import { createReducer } from '@reduxjs/toolkit';
import {
  UPDATE_LINEITEM,
  UPDATE_ISCOPY,
  UPDATE_CONFIG,
  updateConfigProductId
} from '../actions';

/* globals injectedConfiguratorSettings */
/* globals productMetas */
/* globals breadcrumbInfo */

const getInitialState = () => {
  if (typeof window !== 'undefined' && typeof injectedConfiguratorSettings !== 'undefined') {
    return {
      ...injectedConfiguratorSettings,
      ...(typeof productMetas !== 'undefined' ? productMetas : {}),
      breadcrumbs: typeof breadcrumbInfo !== 'undefined' ? breadcrumbInfo : undefined,
    };
  }
  return {
    breadcrumbs: undefined,
  };
};

let configInstance = null;

const getConfig = () => {
  if (!configInstance) {
    configInstance = createReducer(getInitialState(),
      (builder) => {
        builder
          .addCase(UPDATE_CONFIG,
            (state, action) => ({ ...state, configurationId: action.configurationId }))
          .addCase(UPDATE_LINEITEM,
            (state, action) => ({ ...state, lineItemId: action.lineItemId }))
          .addCase(UPDATE_ISCOPY,
            (state, action) => ({ ...state, isCopy: action.isCopy }))
          .addCase(updateConfigProductId,
            (state, action) => ({ ...state, productId: action.payload, partnerProductId: action.payload }));
      }
    );
  }
  return configInstance;
};

export default getConfig;
